import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const baseURL =
  import.meta.env.VITE_NEGOCIACIONES_BACKEND_API_URL ||
  import.meta.env.VITE_INVOICES_BACKEND_API_URL ||
  "http://localhost:4002/api";

const negociacionesApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(negociacionesApi);

negociacionesApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { negociacionesApi };
